import PageTransition from '../components/PageTransition';
import Calculator from "../components/Calculator";
import Why from "../components/Why";
import Reviews from "../components/Reviews";
import FAQ from "../components/FAQ";
import Process from "../components/Process";
import Alts from "../components/Alts";

const CURRENCIES = ['RUB', 'USDT']; // пока только эти реально есть

export default function Exchange() {


    console.log(window.Telegram?.WebApp);
    console.log(window.Telegram?.WebApp?.initDataUnsafe);


    return (
        <PageTransition keyId="exchange">

            <div className={'card'}>

                <h2 className={'uppercase'} style={{marginTop: '4px', marginBottom: '-6px'}}>
                    Мгновенный
                    <br/>
                    расчет обмена
                </h2>

                <p className={'opacity75'} style={{marginBottom: '-2px'}}>
                    Калькулятор покажет актуальный курс, который можно зафиксировать в личных сообщениях с оператором
                </p>

            </div>

            <Calculator/>

            {/*<Alts />*/}

            <FAQ />

            <Why/>

            <Process />

            <Reviews/>

            <div style={{height: '100px'}}>

            </div>

        </PageTransition>
    );
}
